import script from "./TransferRideDate.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferRideDate.vue?vue&type=script&setup=true&lang=js"

import "./TransferRideDate.vue?vue&type=style&index=0&id=b61bbc16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b61bbc16"]])

export default __exports__
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSlideTransition,QBtn,QToggle});
